<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { PanelRightCloseIcon, PanelRightOpenIcon } from '@solar-icons/vue/linear'
import AppButton from '../../primitives/AppButton/AppButton.vue'
import AppTooltip from '../../primitives/AppTooltip/AppTooltip.vue'
import { useSidebar } from './useSidebar'

const { openMobile, toggle } = useSidebar()
const { t } = useI18n()

const label = computed(() =>
  openMobile.value ? t('shell.collapseSidebar') : t('shell.expandSidebar'),
)
</script>

<template>
  <AppTooltip :content="label" placement="right">
    <template #trigger="{ aria }">
      <AppButton
        size="sm"
        variant="ghost-strong"
        icon-only
        :start-icon="openMobile ? PanelRightCloseIcon : PanelRightOpenIcon"
        :aria-label="label"
        :aria-expanded="openMobile"
        v-bind="aria"
        @click="toggle"
      />
    </template>
  </AppTooltip>
</template>
